<template>
    <v-dialog v-model="dialog" max-width="80%">
        <app-card>
            <app-section-loader :status="loading.submit"></app-section-loader>
            <h4>LÊN LỊCH THAY ĐỔI GIÁ INTERNET</h4>
            <p class="fs-14 grey--text">Lên lịch thay đổi giá cho {{ internet_user.user }}</p>
            <v-card-text>
                <v-container fluid>
                    <v-layout row wrap justify-center>
                        <v-flex xs12 md3>
                            <v-text-field label="Tên user" :disabled="true" v-model="internet_user.user"
                                prepend-icon="account_box"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-text-field label="Số phòng" :disabled="true" v-model="internet_user.room_id"
                                prepend-icon="meeting_room"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-text-field label="Loại wifi" :disabled="true" v-model="wifi_type_text"
                                prepend-icon="wifi"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-text-field label="Tên gói cước" disabled v-model="form.package_name"
                                prepend-icon="label"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-text-field label="Tốc độ (Mbps)" disabled v-model="form.speed_mbps"
                                prepend-icon="speed" type="number"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-text-field label="Giá gói cước" disabled v-model="form.price"
                                prepend-icon="money" type="number"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-text-field label="Giá thu KH" :disabled="loading.submit" v-model="form.customer_price"
                                prepend-icon="money" type="number"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-menu :close-on-content-click="false" v-model="menu_effective_date" :nudge-right="40" lazy
                                transition="scale-transition" offset-y full-width min-width="290px">
                                <v-text-field slot="activator" v-model="form.price_effective_date"
                                    label="Ngày bắt đầu áp dụng" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker locale="vi-VI" v-model="form.price_effective_date"
                                    @input="menu_effective_date = false"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs12 md12>
                            <v-textarea label="Ghi chú" :disabled="loading.submit" v-model="form.note"
                                prepend-icon="note" rows="3"></v-textarea>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :disabled="loading.submit" @click="cancelInput">
                    Trở về
                </v-btn>
                <v-btn :loading="loading.submit" :disabled="loading.submit" @click="submit" color="green" dark>
                    Lên lịch thay đổi
                </v-btn>
            </v-card-actions>
        </app-card>
    </v-dialog>
</template>

<script>
import api from "Api";
import { WIFI_TYPE_BADGES } from "Constants/db-config";

export default {
    name: "schedule-price-edit",
    props: {
        dialog: Boolean,
        internet_user: Object
    },
    data() {
        return {
            form: {
                package_name: '',
                speed_mbps: '',
                price: '',
                customer_price: '',
                price_effective_date: '',
                note: ''
            },
            menu_effective_date: false,
            loading: {
                submit: false
            },
            wifi_type_badges: WIFI_TYPE_BADGES
        };
    },
    computed: {
        wifi_type_text() {
            return this.wifi_type_badges[this.internet_user.wifi_type].text || '';
        },
        isAuxiliaryWifi() {
            return this.internet_user.wifi_type === 'auxiliary';
        }
    },
    watch: {
        dialog(newVal) {
            if (newVal) {
                this.initializeForm();
            }
        }
    },
    methods: {
        initializeForm() {
            const initData = this.internet_user.future_changes;
            if (initData) {
                this.form = {
                    package_name: initData.package_name || '',
                    speed_mbps: initData.speed_mbps || '',
                    price: initData.price || '',
                    customer_price: initData.customer_price || '',
                    price_effective_date: initData.price_effective_date || '',
                    note: initData.note || ''
                };
            } else {
                this.form = {
                    package_name: this.internet_user.package_name || '',
                    speed_mbps: this.internet_user.speed_mbps || '',
                    price: this.internet_user.price || '',
                    customer_price: this.internet_user.customer_price || '',
                    price_effective_date: '',
                    note: ''
                };
            }
        },
        cancelInput() {
            this.$emit('close');
        },
        async submit() {
            try {
                console.log(this.form);
                if (!this.form.price_effective_date) {
                    this.$toast.error('Vui lòng chọn ngày bắt đầu áp dụng');
                    return;
                }

                this.loading.submit = true;
                const updateData = {
                    future_changes: {
                        package_name: this.form.package_name,
                        speed_mbps: this.form.speed_mbps,
                        price: this.form.price,
                        customer_price: this.form.customer_price,
                        note: this.form.note,
                        price_effective_date: this.form.price_effective_date
                    },
                };

                const data = await api.updateInternet(this.internet_user._id, updateData);

                if (data.status === 200) {
                    this.$emit('changeDialogState', false);
                    swal.fire('Thành công', 'Lên lịch thành công', 'success');
                    this.$emit('reloadTable');
                } else {
                    swal.fire('Lỗi', data.message, 'error');
                }
            } catch (error) {
                console.error('Lỗi lên lịch thay đổi giá:', error);
                this.$toast.error('Có lỗi xảy ra khi lên lịch thay đổi giá');
            } finally {
                this.loading.submit = false;
            }
        }
    }
};
</script>
